import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M6 12h12", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M6 20V4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M18 20V4", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Heading";
const Heading = memo(themed(Icon));
export {
  Heading
};
//# sourceMappingURL=heading.js.map
